<template lang="pug">
v-bottom-sheet(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-sheet.pa-4(style="border-radius: 16px 16px 0 0;")
    div.d-flex.align-center
      div(style="width: 28px;")
      v-spacer
      .text-md.font-semibold Location involved
      v-spacer
      v-btn(icon @click="closeDialog" small color="primary")
        v-icon mdi-close

    div.d-flex.mt-5
      v-icon(color="neutral700" size="22") $yzi-marker-pin-solid-04
      div.ml-3
        div.text-sm.font-semibold.neutral700--text Location involved ({{ stocktake.summary.locations.length }}):
        ul.mt-1
          template(v-for="location in stocktake.summary.locations")
            li.text-sm.neutral700--text {{ location }}


    v-row.mt-3
      v-col
        y-button(label="Close" color="neutral700" size="sm" dark block @click="closeDialog")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    stocktake: {
      type: Object,
      default: (() => {})
    }
  },
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {},
  methods: {
    ...mapActions(['showMessage']),
    copyLink () {
      let textToCopy = encodeURI(`https://${process.env.VUE_APP_BASE_DOMAIN}/stocktake/${this.stocktake.id}`)
      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          this.showMessage(['success', 'Link copied!'])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        })
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
  }
}
</script>

<style lang="scss" scoped>
.clipboard-custom {
  font-size: 14px;
  color: white;
  background: var(--v-neutral700);
  padding: 2px 12px;
  border-radius: 6px;
}
</style>